import { Component, OnInit } from '@angular/core';
import { PatentDrawingDataForm } from '../_models/patent-drawing-data-form';
import { FormGroup, FormBuilder, FormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { PatentDrawingService } from '../_services/patent-drawing.service';
import { SnotifyService } from 'ng-snotify';
import { ErrorStateMatcher } from '@angular/material';
import { HttpEventType} from '@angular/common/http';
import { SessionActivityDataForm } from '../_models/session-activity-data-form';
import { SuccessDialogService } from '../_services/success-dialog.service';
import { SesssionActivityService } from '../_services/sesssion-activity.service';


@Component({
  selector: 'app-patent-drawing-save-update',
  templateUrl: './patent-drawing-save-update.component.html',
  styleUrls: ['./patent-drawing-save-update.component.css']
})

export class PatentDrawingSaveUpdateComponent implements OnInit {
  userName: string;
  patentDrawingDataForm: PatentDrawingDataForm = new PatentDrawingDataForm();
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm()
  patentDrawingDataFormGroup: FormGroup;
  nextStep: string = 'Next step';
  upload: string = 'upload File';
  request: string = 'sent request';
  projectId: any;
  updateFlag = '';
  currentFileToUpload: File;
  fileUploadStandard = false;
  fileUploadNonStandard = false;
  fileUploadAgain = false;
  fileFormat = false;
  progressBar = false;
  progress = 0;
  doingStatusSelected: string = 'Patent Drawing';
  projectTitle: String = '';


  standardFileToUpload: File;
  nonStandardFileToUpload: File;
  standardFileName: any = '';
  nonStandardFileName: any = '';
  userDetailsId: number;
  userDataSession;
  respForDailog;

  drawingStandardStatusList: string[] = [
    'Yes',
    'No'
  ]

  constructor(
    private snotifyService: SnotifyService,
    private formbuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private patentDrawingService: PatentDrawingService,
    private successDialogService: SuccessDialogService,
    private sesssionActivityService: SesssionActivityService,
    private authService: AuthService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.projectId = params['id'];
      this.updateFlag = 'true';
    });
  }

  ngOnInit() {
    this.patentDrawingFormValidate();
    if (this.updateFlag == 'true' && this.projectId > 0) {
      this.getDrawingByProjectId(this.projectId);
    }

    this.userDataSession = this.authService.getUserData();
    this.userDetailsId = this.userDataSession.userDetailsId;

  }

  patentDrawingFormValidate() {
    this.patentDrawingDataFormGroup = this.formbuilder.group({
      drawingStandardStatus: ['', [Validators.required]],
      drawingStandardDocument: ['', [Validators.required]],
    })
  }


  validateFile(name: string) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'pdf') {
      return true;
    }
    else {
      this.fileFormat = true;
      return false;
    }
  }


  standardFile(event) {
    this.progress = 0;
    this.progressBar = false;
    this.fileFormat = false;
    this.standardFileToUpload = event.target.files[0];
    this.standardFileName = this.standardFileToUpload.name;

    if (!this.validateFile(this.standardFileName)) {
      return false;
    }
  }


  standardFileUpload() {
    // this.spinnerService.show();
    this.progressBar = true;
    this.sessionActivityDataForm.activityType = 7;
    let indexNumber = 1;
    this.sessionActivityDataForm.lastActivitySession = indexNumber;
    this.patentDrawingDataForm.sessionActivityDataForm = this.sessionActivityDataForm;

    const currentUser = localStorage.getItem('currentUser');
    this.patentDrawingDataForm.userSessionDataForm = JSON.parse(currentUser);
    this.patentDrawingService.uploadInventionDrawing(this.patentDrawingDataForm, this.standardFileToUpload).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round(100 * event.loaded / event.total);
          this.progress = percentDone;
        }
      },

      resp => {

        //  this.patentDrawingDataForm = resp as PatentDrawingDataForm()
        let userData = JSON.stringify(resp);
        let UserDataObj = JSON.parse(userData.toString());

        if (UserDataObj.body === undefined) {
        } else {
          this.patentDrawingDataForm = UserDataObj.body;
          this.projectTitle = this.projectTitle;
        }
      //  this.spinnerService.hide();
      }),
      error => {
        console.log(error);
        this.snotifyService.error(error);
     //   this.spinnerService.hide();
      }

  }

  gotoPatenetSearch() {
    this.sesssionActivityService.getProjectLastSessionActiityForRedirection(this.userDetailsId, 7, this.projectId).subscribe(
      resp => {
        this.respForDailog = resp;

       // console.log(resp);

        if (this.respForDailog.activityType < 8) {
          this.successDialogService.successDialogDoing(7, this.projectId);
        } else {
          this.router.navigate(['/main/patentSearch', this.projectId]);

        }
      }, error => {
        console.log(error);
      })
  }

  getDrawingByProjectId(id) {

    this.patentDrawingService.getPatentDrawingByPojectId(id).subscribe(
      resp => {
        this.patentDrawingDataForm = resp as PatentDrawingDataForm;
        this.projectTitle = this.patentDrawingDataForm.projectDataForm.projectName;
        this.standardFileName = this.patentDrawingDataForm.fileName;
      }, error => {
        console.log(error);
      })

  }
}

// ===== ErrorStateMatcher =====
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (isSubmitted));
  }
}